const OBJECT_SIDEBAR_TOUR_TARGET_PREFIX = 'object-sidebar-tour-target:';

// Note: circular dependency between redactions and object-sidebar-components avoided
// by recreating SIDEBAR_DETAIL_BUTTON target to match this value. Please update this if the target changes.
export const OBJECT_SIDEBAR_TOUR_TARGETS = {
	MORE_ACTIONS_ITEMS: `${OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}more-actions-items`,
	OBJECT_SIDEBAR_CONTROL: `${OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}object-sidebar-control`,
	SIDEBAR_DETAILS_BUTTON: `${OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}sidebar-details-button`,
};
